import {ItemRemoval} from "./types";
import {BoxAccess, usePlatform, usePreventDeactivate} from "@variocube/cube-ui";
import * as React from "react";
import {useCallback} from "react";
import {useLocalization} from "../../i18n";

export interface RemovalFlowProps {
    removal: ItemRemoval;
    onDone: () => void;
}

export function RemovalFlow({removal, onDone}: RemovalFlowProps) {
    const platform = usePlatform();
    const {t} = useLocalization();
    const {item, occupancy, box} = removal;

    const handleConfirm = useCallback(async () => {
        try {
            await platform.endOccupancy(occupancy.uuid);
            onDone();
        }
        catch (error) {
            console.error("Could not end occupancy", error);
        }
    }, [platform, occupancy, onDone]);

    usePreventDeactivate();

    return (
        <BoxAccess
            boxes={box}
            platform={platform}
            onConfirm={handleConfirm}
            onCancel={onDone}
            allowCancelWhenOpen
            boxOpenTitle={t("RemoveItem")}
            boxOpenMessage={t("RemoveItemMessage", {item: item.name, boxNumber: box.number})}
            confirmTitle={t("ConfirmRemoval")}
            confirmMessage={t("ConfirmRemovalMessage", {item: item.name, boxNumber: box.number})}
            strings={t}
            timeout={true}
            onTimeout={'confirm'}
        />
    )

}